'use strict';

var $ = require('jquery');

var progress = require('../../utils/progress');
var showLoading = require('../../utils/showLoading');
var applePay = require('./applepay_ui');

import {debounce} from '../../components/custom-lodash';
import initializeBlikSummary from './blik/blik_summary';

function updateMediaQueryHelper() {
    var $mq = $('.jsMediaQueryHelper');
    $mq.show();
    $mq.find('input').val($mq.find(':visible').html());
    $mq.hide();
}

function updateAddress(selector, url, value) {
    var $address = $(selector);
    // indicate progress
    progress.show($address);

    // load the updated address
    $.get(url, {value: value}, function (data) {
        $address.html($(data).children('div'));
        progress.hide();
    });
}

exports.init = function () {
    var $summarySalutation = $('.summary-salutation'),
        salutationValue = false,
        $notAvailable = $('.notavailable'),
        formToSubmit = document.getElementById('dwfrm_summary'),
        button = document.getElementById('dwfrm_summary_save');

    applePay.init();

    // if on the order review page and there are products that are not available disable the submit order button
    if ($notAvailable.length > 0) {
        $('.order-summary-footer button.button-large').attr('disabled', 'disabled');
    }

    if ($summarySalutation.length > 0) {
        $summarySalutation.on('change', 'select', function () {
            salutationValue = $summarySalutation.find('option:selected').val();
            if (salutationValue) {
                updateAddress(
                    '.checkout-mini-details-item.shipping-address',
                    Urls.summaryRefreshShippingURL,
                    salutationValue
                );
                updateAddress(
                    '.checkout-mini-details-item.billing-address',
                    Urls.summaryRefreshBillingURL,
                    salutationValue
                );
                if ($notAvailable.length === 0) {
                    $('.order-summary-footer button').prop('disabled', false);
                }
            }
        });
    }
    $('.step.active').attr('aria-current', 'step');

    $(window).on('resize orientationchange', debounce(updateMediaQueryHelper, 10));
    updateMediaQueryHelper();

    var isBlikPayment = $('#blikCodeSummary').length;

    if (isBlikPayment) {
        initializeBlikSummary(formToSubmit);
    } else {
        showLoading.showLoading(formToSubmit, button);
    }
};

/**
 * Submits SFCC 3ds form on back to cart button.
 *
 * @returns {void}
 */
exports.attachBackBtnEvent = () => {
    $(window).on('load', () => {
        const authenticate3dsForm = $('#3dform');

        if (authenticate3dsForm.length > 0) {
            $('.back-to-cart').on('click', e => {
                e.preventDefault();
                authenticate3dsForm.trigger('submit');
            });
        }
    });
};
